export const IMAGE = 'image';
export const EDITABLE_IMAGE = 'image';
